import { pageTitle } from '@utility/constants/common';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';
import { brand } from '@utility/config';

const getTitle = (page: string): string => {
  const title = pageTitle?.[page];
  return title ? `${brand.name} - ${title}` : brand.name;
};

export function SkupremeMetadata() {
  const { pathname } = useLocation();
  return (
    <Helmet>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1,minimum-scale=1,maximum-scale=1.0,user-scalable=no,target-densitydpi=device-dpi"
      />
      <meta
        name="description"
        content={`${brand.name} is a supply chain management solution, listings sync manager, and order fulfillment software all in one.`}
      />
      <meta
        name="facebook-domain-verification"
        content="rxrvzwl9kma9zp62f0a3n0otxwc670"
      />
      <meta property="og:url" content="https://www.skupreme.com/" />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content={`${brand.name} - Optimize Your E-commerce Supply Chain`}
      />
      <meta
        property="og:description"
        content={`${brand.name} is a supply chain software that integrates with Amazon, Walmart, eBay, and Google to optimize your order fulfillments, item listings, and supply chain movements.`}
      />
      <meta
        property="og:image"
        content="https://cdn.skupreme.com/public/preview-link-banner.png"
      />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta
        property="og:image:alt"
        content={`${brand.name} - Optimize Your E-commerce Supply Chain`}
      />
      <title>{getTitle(pathname || '')}</title>
    </Helmet>
  );
}
